/*
 * @Author: 刘小博
 * @Date: 2023-02-08 14:18:10
 * @LastEditTime: 2023-02-19 19:05:22
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: /p2ps_vip_web/src/router/behavior-manage/compliance-manage/modules/complianceReportRouter.js
 * 合规报告
 */
const complianceReportRouter = [
  // 行为管理 合规报告导出
  {
    path: '/behaviorManage/compliance-report/:meta_type',
    name: 'behaviorManageComplianceReport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage5" */
      //   '@/views/behaviorManage/dataAnalysis/ComplianceReport.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManage5" */
        '@/views/behavior-manage/compliance-manage/compliance-report/Export.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '合规报告', //二级菜单
      isMoreMeta: true,
      1: {
        title: '拜访合规报告导出',
      },
      2: {
        title: '活动合规报告导出',
      },
      3: {
        title: '医院开发合规报告',
      },
      4: {
        title: '医生助手报告导出',
      },
    },
  },
  // 合规报告 拜访清单
  {
    path: '/behaviorManage/visit-inventory',
    name: 'behaviorManageVisitInventory',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisitInventory" */
      //   '@/views/behaviorManage/VisitInventory.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisitInventory" */
        '@/views/behavior-manage/compliance-manage/compliance-report/visit-list/Page.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '合规报告', //二级菜单
      title: '拜访清单',
    },
  },
  // 合规报告 拜访清单详情
  {
    path: '/behaviorManage/visit-inventory-details/:id',
    name: 'behaviorManageVisitInventoryDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisitInventoryDetails" */
      //   '@/views/behaviorManage/VisitInventoryDetails.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisitInventoryDetails" */
        '@/views/behavior-manage/compliance-manage/compliance-report/visit-list/Detail.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '合规报告', //二级菜单
      title: '拜访清单详情',
      breadcrumb: [
        {
          title: '拜访清单',
          name: 'behaviorManageVisitInventory',
        },
      ],
    },
  },
  // 市场调研报告
  {
    path: '/behaviorManage/purchase-report',
    name: 'behaviorManagePurchaseReport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePurchaseReport" */
      //   '@/views/behaviorManage/purchase-report/List'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManagePurchaseReport" */
        '@/views/behavior-manage/compliance-manage/compliance-report/market-research/Page.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '合规报告', //二级菜单
      title: '市场调研报告',
    },
  },

  // 市场调研报告详情
  {
    path: '/behaviorManage/purchase-report/detail/:purchase_report_id',
    name: 'behaviorManagePurchaseReportDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManagePurchaseReport" */
      //   '@/views/behaviorManage/purchase-report/Detail'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManagePurchaseReport" */
        '@/views/behavior-manage/compliance-manage/compliance-report/market-research/Detail.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '合规报告', //二级菜单
      title: '市场调研报告详情',
      breadcrumb: [
        {
          title: '市场调研报告',
          name: 'behaviorManagePurchaseReport',
        },
      ],
    },
  },
  // 医生助手报告
  {
    path: '/behaviorManage/oa/approve-list2',
    name: 'behaviorManageOaApproveList2',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOa" */
      //   '@/views/behaviorManage/oa/ApproveList2.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOa" */
        '@/views/behavior-manage/compliance-manage/compliance-report/DoctorAssistantReport.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: 'OA审批',
    },
  },
]

export default complianceReportRouter
